// src/components/dashboard/EstimatesByStatus.js
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { FaChartPie } from 'react-icons/fa';
import DashboardCard from './DashboardCard';
import styled from 'styled-components';

const ChartContainer = styled.div`
  height: 300px;
  width: 100%;
`;

const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: ${props => props.theme.colors.textSecondary};
`;

// Status colors for the chart
const STATUS_COLORS = {
  'Draft': '#9e9e9e',     // Gray
  'Sent': '#2196f3',      // Blue
  'Viewed': '#f9a825',    // Amber
  'Accepted': '#4caf50',  // Green
  'Declined': '#f44336',  // Red
  'Expired': '#795548',    // Brown
  'Completed': '#ffffff'  // White
};

const EstimatesByStatus = ({ data, loading, error }) => {
  // Transform data for the chart, handling both array and object formats
  let chartData = [];
  
  if (data) {
    // If data is an array, process as before
    if (Array.isArray(data)) {
      chartData = data.map(item => ({
        name: item.status,
        value: Number(item.count),
        color: STATUS_COLORS[item.status] || '#9e9e9e'
      }));
    } 
    // If data is an object (key-value pairs of status-count)
    else if (data && typeof data === 'object') {
      chartData = Object.entries(data)
        .filter(([status, count]) => status !== 'totalItems') // Exclude any non-status fields
        .map(([status, count]) => ({
          name: status,
          value: Number(count),
          color: STATUS_COLORS[status] || '#9e9e9e'
        }));
    }
  }

  // Filter out any items with zero value to avoid empty segments in the chart
  chartData = chartData.filter(item => item.value > 0);

  console.log('chartData:', chartData);

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
    const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);

    return percent > 0.05 ? (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    ) : null;
  };

  return (
    <DashboardCard
      title="Estimates by Status"
      icon={<FaChartPie />}
      viewAllLink="/estimates"
      loading={loading}
      error={error}
    >
      {chartData.length > 0 ? (
        <ChartContainer>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={100}
                innerRadius={60}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value) => [`${value} Estimates`, 'Count']}
                contentStyle={{
                  backgroundColor: '#333',
                  border: 'none',
                  borderRadius: '4px',
                  color: '#fff'
                }}
              />
              <Legend
                layout="horizontal"
                verticalAlign="bottom"
                align="center"
              />
            </PieChart>
          </ResponsiveContainer>
        </ChartContainer>
      ) : (
        <NoDataContainer>No estimates data available</NoDataContainer>
      )}
    </DashboardCard>
  );
};

export default EstimatesByStatus;
